'use strict';
import * as $i_$0040ui5$002fwebcomponents$002dlocalization$002fdist$002fAssets$002ejs from "@ui5/webcomponents-localization/dist/Assets.js";
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fDatePicker$002ejs from "@ui5/webcomponents/dist/DatePicker.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_DatePicker$() {
  this.CT = null;
  this.CR = null;
  this.CS = false;
  $n_Lbe_doeraene_webcomponents_ui5_DatePicker$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fDatePicker$002ejs.default;
  $i_$0040ui5$002fwebcomponents$002dlocalization$002fdist$002fAssets$002ejs;
  this.CT = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-date-picker", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_DatePicker$ as $c_Lbe_doeraene_webcomponents_ui5_DatePicker$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_DatePicker$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_DatePicker$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_DatePicker$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_DatePicker$ as $h_Lbe_doeraene_webcomponents_ui5_DatePicker$ };
$h_Lbe_doeraene_webcomponents_ui5_DatePicker$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.CT;
});
$p.Bv = (function() {
  if ((!this.CS)) {
    this.CR = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "format-pattern", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.CS = true;
  }
  return this.CR;
});
var $d_Lbe_doeraene_webcomponents_ui5_DatePicker$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_DatePicker$, "be.doeraene.webcomponents.ui5.DatePicker$", ({
  gf: 1,
  ar: 1,
  b8: 1,
  c0: 1,
  bG: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_DatePicker$ as $d_Lbe_doeraene_webcomponents_ui5_DatePicker$ };
var $n_Lbe_doeraene_webcomponents_ui5_DatePicker$;
function $m_Lbe_doeraene_webcomponents_ui5_DatePicker$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_DatePicker$)) {
    $n_Lbe_doeraene_webcomponents_ui5_DatePicker$ = new $c_Lbe_doeraene_webcomponents_ui5_DatePicker$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_DatePicker$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_DatePicker$ as $m_Lbe_doeraene_webcomponents_ui5_DatePicker$ };
